import React from 'react';
import { Select } from 'tea-component';
import useLanguage from '@op/hooks/useLanguage';
import { SortBy } from 'tea-component/lib/table/addons';
import './index.scss';

export default function SortBySelect(props: {
  options: Array<{ text: string; value: string }>;
  sortBy: SortBy<any>;
  changeSortBy: (sortBy: SortBy<any>) => void;
  className?: string;
}) {
  const { options, sortBy, changeSortBy, className } = props;
  const { formatMessage, formatOptionsMessage } = useLanguage();

  return (
    <Select
      className={`dbo-sort-select ${className ? className : ''}`}
      appearance="button"
      options={formatOptionsMessage(options)}
      value={sortBy.by}
      matchButtonWidth
      onChange={(value) => {
        changeSortBy({ order: 'desc', by: value });
      }}
      button={(option) => {
        return (
          <div className="select-button">
            <span className="select-button-text">
              {formatMessage({ id: 'Sort By' })}
            </span>
            <span className="dbo-select-flex">{option?.text}</span>
          </div>
        );
      }}
    />
  );
}
